// Extract field-specific errors from API response
export const getFieldError = (error, fieldName) => {
  if (!error?.errors || !Array.isArray(error.errors)) {
    return null;
  }

  const fieldError = error.errors.find((err) => {
    // Handle both "body.fieldName" and "fieldName" formats
    return err.field === fieldName || err.field === `body.${fieldName}`;
  });

  return fieldError?.detail || null;
};

// Extract all field errors from API response as an object
export const extractFieldErrors = (error) => {
  if (!error?.errors || !Array.isArray(error.errors)) {
    return {};
  }

  const errors = {};
  error.errors.forEach((err) => {
    // Extract field name from "body.fieldName" format
    const fieldName = err.field?.replace('body.', '');
    if (fieldName && err.detail) {
      errors[fieldName] = err.detail;
    }
  });

  return errors;
};

export const formatApiErrorMessage = (
  errorData,
  fallback = 'خطایی رخ داده است',
) => {
  const message = errorData?.message || fallback;
  const firstDetail = Array.isArray(errorData?.errors)
    ? errorData.errors.find((error) => error?.detail)?.detail
    : null;

  if (!firstDetail || message.includes(firstDetail)) return message;
  return `${message}: ${firstDetail}`;
};
